import { createAction } from '@reduxjs/toolkit'

export const httpUnauthorizedAction = createAction('HTTP_UNAUTHORIZED')
